export enum AppointmentTimeIcon {
  CALENDAR = 'Calendar',
  GROUP = 'Group',
}

export enum CalendarListTypeOption {
  DAILY_VIEW = 'daily-view',
  WEEKLY_VIEW = 'weekly-view',
  GROUPS = 'groups',
}

export const SCHEDULE_APPOINTMENT_OPTION = 'Schedule appointment';
export const EDIT_APPOINTMENT_OPTION = 'Edit appointment';
export const REGISTER_FOR_GROUP_OPTION = 'Register for group';
